// extracted by mini-css-extract-plugin
export default {"Wrapper":"PasswordRecovery_Wrapper__YTtnj","Logo":"PasswordRecovery_Logo__F14-1"};